const GET_STATS_VISITORS_START = "GET_STATS_VISITORS_START"
const GET_STATS_VISITORS_SUCCESS = "GET_STATS_VISITORS_SUCCESS"
const GET_STATS_VISITORS_FAILED = "GET_STATS_VISITORS_FAILED"

export {
    GET_STATS_VISITORS_START,
    GET_STATS_VISITORS_SUCCESS,
    GET_STATS_VISITORS_FAILED
}